import { Component, OnInit, Inject } from '@angular/core';
import { WebObjectTypeService } from 'src/app/Services/web-object-type.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { WebObjectTypeModel } from 'src/app/Models/web-object-type-model';
import { PageServiceService } from 'src/app/Services/page-service.service';
import { FormGroup } from '@angular/forms';
import { StepServiceService } from 'src/app/Services/step-service.service';
import { Router } from '@angular/router';
import { ValidationService } from 'src/app/Services/validation.service';
import { NotifyService } from 'src/app/Services/notify.service';

@Component({
  selector: 'ze-add-web-object',
  templateUrl: './add-web-object.component.html',
  styleUrls: ['./add-web-object.component.scss']
})
export class AddWebObjectComponent implements OnInit {
  public newElement: any;
  public selectedWebPageId: any;
  public selectedWebPageName: any;
  public selectedElement;
  public webobjecttype: WebObjectTypeModel[];
  webpages: any = [];
  webpage: string = "";
  newWP: any;
  showModal: string = 'selectWebPageOption';
  formgroup = FormGroup;
  public filterdWebPages = [];
  // public webpageSearch = "";
  public webpagedb2: any;
  public stepId;
  displayValue: String = "";
  showCreateOption: boolean = false;
  hideSearchBox: boolean = true;
  isStudioPage: boolean = false;
  public currentPageName: string;
  public selectedWebPage: any;

  constructor(
    public router: Router,
    private webObjectTypeService: WebObjectTypeService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<any>,
    private pageServices: PageServiceService,
    private notifys: NotifyService,
    private validateService: ValidationService) {
    this.webobjecttype = this.webObjectTypeService.getItems();
    data.element == undefined ? this.newElement = {
      _id: "",
      dom_name: "",
      name: "",
      xpaths: [""],
      dom_id: "",
      class: "",
      css: "",
      link: "",
      horizontal_index:"",
      partial_link: "",
      tag: "",
      webobjectType: "",
      desc: "",
      webpageId: { $oid: "" },
      primary_locator: null
    } : this.newElement = (data.element);
    console.log(data);
    if (data.element && Array.isArray(data.element.xpaths) && data.element.xpaths.length > 0) {
      // Add data.element.xpaths to newElement variable
      this.newElement.xpaths = data.element.xpaths;
      // Now newElement contains the array data.element.xpaths
      console.log("newElement:", this.newElement);
    }
    this.selectedWebPageId = data.webpage ? data.webpage : '';
    this.showModal = data.showView ? data.showView : this.showModal;
    this.stepId = data.stepId;
    if (this.router.url.includes('/canvas')) {
      this.isStudioPage = false;
      this.getWebPagesdb2();
    }
    else {
      this.isStudioPage = true;
      this.newElement.changedwebpageId = "";
      this.getWebPages();
    }
  }

  toggleRadio(value: string): void {
    if (this.newElement.primary_locator === value) {
      // Deselect the currently selected radio button
      this.newElement.primary_locator = null;
    } else {
      // Select the new radio button
      this.newElement.primary_locator = value;
    }
  }

  saveDialog() {
    if (this.validateService.isPrimaryLocatorEmpty(this.newElement)) {
      this.notifys.notify('warning', 'Empty Primary Locator', "Primary locator value is empty");
      return;
    }
    if (this.newElement["priority"]) {
      if (this.newElement["priority"][0]["timeTaken"]["$numberLong"]) {
        this.newElement["priority"][0]["timeTaken"] = Number(this.newElement["priority"][0]["timeTaken"]["$numberLong"]);
      }
    }
    this.newElement["type"] = "WEB";
    this.dialogRef.close(this.newElement);
  }

  ngOnInit() {
  }

   // or item.id or any unique value

  trackByFn(index: number, item: any): any {
    return index;
  }

  getValue(val: String) {
    this.displayValue = val;
    this.showCreateOption = false;
    let showCreateOptionflag = false;
    for (let webpage of this.webpages) {
      if (webpage.name == val) {
        showCreateOptionflag = true;
        break;
      }
    }
    if (!showCreateOptionflag) {
      this.showCreateOption = true;
    }
  }
  initForm() {
  }
  onCloseClick(): void {
    this.dialogRef.close();
  }
  createPagebtn() {
    this.showModal = 'createpageoption';
    this.hideSearchBox = !this.hideSearchBox;
    this.newElement.wpname = this.displayValue;
    this.newElement.wpdesc = "";
    this.newElement.wpurl = "";
  }
  displayobject(page) {
    this.newElement.selectedWebPageId = page._id;
  }
  getWebPages() {
    this.pageServices.getItems().subscribe(data => {
      // if(webpagesVar)
      //   this.webpages = webpagesVar.concat(this.webpages.concat(data['data'].filter(Boolean)) );
      //   else
      this.webpages = this.webpages.concat(data['data'].filter(Boolean));
      this.filterdWebPages = this.webpages.map(x => Object.assign({}, x));
      this.newElement.selectedWebPageId = this.selectedWebPageId;
    });
  }
  getWebPagesdb2() {
    // this.stepService.getWebPagesByStepIddb2(this.stepId).subscribe(data => {
    this.pageServices.getdb2Items().subscribe(data => {
      this.webpages = (data['data'].filter(Boolean));
      this.getWebPages();
    });
  }
  backBtn() {
    this.showModal = 'selectWebPageOption';
  }
  searchWebPage(searchfield) {
    this.filterdWebPages = this.webpages.filter(webpage => {
      return webpage.name.includes(searchfield);
    });
  }

  getcurrnetPageName(webPageId): String {
    return this.webpages.find((webpage) => {
      if (webpage._id.$oid == webPageId || webpage._id == webPageId) {
        this.webpage = webpage.name;
        return webpage;
      }
    })

  }

  onSelectionChange(): void {
    if (this.selectedWebPage) {
      this.webpages.find((wp) => {
        if (wp.name == this.selectedWebPage)
          this.newElement.selectedWebPageId = wp._id;
      })
    }
  }

  addXPath() {
    if (!this.newElement.xpaths) {
      this.newElement.xpaths = [];
    }
    this.newElement.xpaths.push('');
  }

}
